import { useEffect, useState } from 'react';
import { useContext } from 'react';
import { useSearchParams } from 'react-router-dom';
import ConfigContext from '../contexts/ConfigContext';
import AppContext from '../contexts/AppContext';

import useInterval from '../hooks/useInterval';
import usePrevious from '../hooks/usePrevious';

import logoGenability from './../images/logo_solargraf.png';
import logoFema from './../images/logo_fema.png';
import logoSunroof from './../images/logo_sunroof.png';

import iconPermit from './../images/lander-concept-icon-permit.svg';
import iconFinance from './../images/lander-concept-icon-finance.svg';
import iconPanels from './../images/lander-concept-icon-panels.svg';
import iconInstaller from './../images/lander-concept-icon-installer.svg';
import iconMicroinverter from './../images/lander-concept-icon-microinverter.svg';
import iconBattery from './../images/lander-concept-icon-battery.svg';

export function LanderConceptHeader() {
  const [searchParams] = useSearchParams();
  const currentParams = Object.fromEntries(searchParams.entries());

  return currentParams.s4 && currentParams.s4.length <= 54 ? (
    <div className="text-white text-center mt-[-10px] mb-5 md:mb-[50px]">
      <p className="text-[24px] md:text-[42px] leading-8 md:leading-normal">
        {currentParams.s4}
      </p>
    </div>
  ) : null;
}

export function LanderConceptFooter() {
  const configData = useContext(ConfigContext);
  const { ISRAppointmentDetails } = useContext(AppContext);
  const { features } = configData;

  return (
    <div className="text-white text-center mt-10 md:mt-16 md:mb-6 md:w-[805px] ml-auto mr-auto">
      {!features.shortISRFeatureForm && (
        <>
          {!ISRAppointmentDetails && (
            <p className="text-[17px] md:text-[32px]">
              Complete the above form and see what you could save
            </p>
          )}
          <br></br>
        </>
      )}
      {/* {isDebrandedVersion && <br></br>}
      {!isDebrandedVersion && <LanderConceptCards />} */}
      <div className="flex flex-wrap gap-6 md:gap-10 justify-center mt-6 mb-6">
        <img alt="" src={logoGenability} className="h-5 md:h-7 m-3 md:m-5" />
        <img alt="" src={logoFema} className="h-5 md:h-7 m-3 md:m-5" />
        <img alt="" src={logoSunroof} className="h-5 md:h-7 m-3 md:m-5" />
      </div>
      <hr className="mt-6"></hr>
    </div>
  );
}

type CardData = { icon: string; text: string };

const cardsData: CardData[] = [
  {
    icon: iconPermit,
    text: 'Complete Solar Report: Your Solar & Battery configuration will be optimized for bill savings.',
  },
  {
    icon: iconFinance,
    text: 'Explore your savings and federal incentives: Save thousands on your taxes and electricity bill.',
  },
  {
    icon: iconPanels,
    text: 'Enphase has helped approx. 3.3 million homeowners go solar in more than 145 countries.',
  },
  {
    icon: iconInstaller,
    text: 'There are more than 1,400 installers in the Enphase installer network.',
  },
  {
    icon: iconMicroinverter,
    text: 'Enphase has shipped over 63 million microinverters representing approx. 21GW.',
  },
  {
    icon: iconBattery,
    text: 'Enphase has shipped more than 900 MWh of energy storage systems.',
  },
];

function LanderConceptCard({
  cardData,
  className,
}: {
  cardData: CardData;
  className: string;
}) {
  const [contentOpacity, setContentOpacity] = useState('opacity-1');
  const previousCardData: CardData = usePrevious(cardData)!;
  const [currentCardData, setCurrentCardData] = useState(previousCardData);

  useEffect(() => {
    setContentOpacity('opacity-0');
    setTimeout(() => {
      setCurrentCardData(cardData);
      setContentOpacity('opacity-1');
    }, 700);
  }, [cardData]);

  return (
    <div
      className={`rounded-[12px] bg-[#DCDCD6] flex flex-col text-black text-[17px] md:text-[20px] text-left p-4 gap-2 min-h-[160px] md:min-h-[180px] ${className}`}>
      <div className={`transition-opacity duration-1000 ${contentOpacity}`}>
        <img
          alt=""
          src={currentCardData && currentCardData.icon}
          className="p-2"
        />
      </div>
      <div className={`transition-opacity duration-1000 ${contentOpacity}`}>
        <p>{currentCardData && currentCardData.text}</p>
      </div>
    </div>
  );
}

function LanderConceptCards() {
  const [cardIndexOne, setCardIndexOne] = useState(0);
  const [cardIndexTwo, setCardIndexTwo] = useState(1);

  useEffect(() => {
    const getRandomIndex = () => Math.floor(Math.random() * cardsData.length);
    const firstIndex = getRandomIndex();
    let secondIndex = getRandomIndex();
    while (firstIndex === secondIndex) {
      secondIndex = getRandomIndex();
    }
    setCardIndexOne(firstIndex);
    setCardIndexTwo(secondIndex);
  }, []);

  useInterval(() => {
    setCardIndexOne((cardIndexOne + 1) % cardsData.length);
    setCardIndexTwo((cardIndexTwo + 1) % cardsData.length);
  }, 8000);

  return (
    <div className="flex flex-col md:flex-row mt-6">
      <LanderConceptCard
        cardData={cardsData[cardIndexOne]}
        className="basis-1/2 m-2"
      />
      <LanderConceptCard
        cardData={cardsData[cardIndexTwo]}
        className="basis-1/2 m-2"
      />
    </div>
  );
}
